<template>
  <div>
    <form
      v-show="!isProcessing"
      id="payment-form"
      method="POST"
      action="https://merchant.com/charge-card"
      class="form-payment"
      :class="{ loading: isLoading }"
    >
      <!-- <div v-if="isPriceLoading" class="block-loading" /> -->
      <div v-if="true" class="plan-details-shop w-100">
        <TextBlock
          tag="div"
          class="mb-4"
          style="color:rgba(255, 255, 255, 1);font-size: 1.5rem !important;"
        >
          {{ $t(`_web_checkout_shop-payment`, 'Payment') }}
        </TextBlock>
        <div class="divider-payment"></div>
        <div class="name-amount d-flex justify-content-between mb-4">
          <TextBlock class="d-flex mb-2">
            {{ $t(`_web_checkout_shop-Item`, 'Item') }}
          </TextBlock>
          <div>
            <TextBlock
              class="item-title-shop-checkout"
              style="color:rgba(255, 255, 255, 1)"
            >
              {{ SelectedProduct.name }}
            </TextBlock>
          </div>
        </div>
        <div class="name-amount d-flex justify-content-between mb-4">
          <div>
            <TextBlock class="secondary-font">
              {{ $t(`_web_checkout_shop-Quantity`, 'Quantity:') }}
            </TextBlock>
          </div>
          <div class="qty">
            <TextBlock style="color:rgba(255, 255, 255, 1)">{{
              quantity
            }}</TextBlock>
          </div>
        </div>
        <div class="name-amount d-flex justify-content-between mb-4">
          <TextBlock class="">
            {{ $t(`_web_checkout_shop-regular-price_v2`, 'Regular Price:') }}
          </TextBlock>
          <div class="price">
            <TextBlock
              class="font-weight-bold"
              style="color:rgba(255, 255, 255, 1)"
              >{{ $$t(SelectedProduct.item_price.currency) }}</TextBlock
            >
            <TextBlock
              v-if="cart && SelectedProduct.item_price.discount_amount"
              style="color:rgba(255, 255, 255, 1)"
            >
              {{ cart.itemTotal }}
            </TextBlock>
            <TextBlock v-else style="color:rgba(255, 255, 255, 1)">
              {{ SelectedProduct.item_price.base_price }}
            </TextBlock>
          </div>
        </div>
        <div
          v-if="!SelectedProduct.item_price.discount_amount"
          class="coupon d-flex justify-content-between  mb-5"
        >
          <HeraInput
            v-model="couponCode"
            :disabled="couponApplied"
            :label="$t(`_web_checkout_shop-promo-code`, 'Promo code')"
            :placeholder="
              $t(`_web_checkout_shop-enter-promocode`, 'Enter promocode')
            "
            :error="couponError"
            :class="{
              'is-invalid': !!couponError,
            }"
            class="coupon-input"
          />
          <Btn
            class="apply-coupon-button btn-accent d-flex align-items-center justify-content-center"
            :label="
              couponApplied
                ? $t('_web_shop_applied', 'Applied')
                : $t('_web_shop_applly', 'Apply')
            "
            :loading="isCouponChecking"
            :disabled="!couponCode || couponApplied"
            @click="apply"
          />
        </div>
        <div class="total d-flex justify-content-between mb-4">
          <div>
            <TextBlock class="secondary-font">
              {{
                $t(`_web_checkout_shop-discount-applied`, 'Discount applied:')
              }}
            </TextBlock>
          </div>
          <div class="font-weight-bold">
            <TextBlock
              v-if="cart.couponId === null"
              style="color:rgba(255, 255, 255, 1)"
              >{{ SelectedProduct.item_price.discount_amount || 0 }}
              {{
                SelectedProduct.item_price.discount_type === 2
                  ? '%'
                  : SelectedProduct.item_price.currency
              }}</TextBlock
            >
            <TextBlock v-else style="color:rgba(255, 255, 255, 1)"
              >{{ cart.coupon_discount || 0 }}
              {{
                cart.coupon_discount_type === 2
                  ? '%'
                  : SelectedProduct.item_price.currency
              }}</TextBlock
            >
          </div>
        </div>
        <div class="total d-flex justify-content-between mb-5">
          <div>
            <TextBlock class="secondary-font">
              {{ $t('_web_subscription_total-incl-vat', 'Total incl VAT:') }}
            </TextBlock>
          </div>
          <div class="font-weight-bold">
            <TextBlock style="color:rgba(255, 255, 255, 1)">{{
              $$t(SelectedProduct.item_price.currency)
            }}</TextBlock>
            <TextBlock
              v-if="
                cart &&
                  cart.total &&
                  !SelectedProduct.item_price.discount_amount
              "
              style="color:rgba(255, 255, 255, 1)"
            >
              {{ cart.total }}
            </TextBlock>
            <TextBlock v-else style="color:rgba(255, 255, 255, 1)">
              {{ SelectedProduct.item_price.base_price }}
            </TextBlock>
          </div>
        </div>
      </div>
      <div
        class="payment-user-options"
        :style="provider !== 'fort' ? '' : 'gap: 30px;min-height: 540px;'"
      >
        <div
          v-if="paymentUserOption === ''"
          class="payment-option-wrapper"
          style="min-height: 260px;margin-bottom: 0px;"
        >
          <span class="payment-method" style="color: white;">
            {{ $t('_web_subscription_payment-method', 'Payment Method:') }}
          </span>
          <!-- hardcoded false to applepay-->
          <div
            v-if="$flagsmith.flags.payment_apple_pay_enabled.value && false"
            class="payment-option"
            @click="selectPaymentOption('applePay')"
          >
            <div class="option-wrapper">
              <div class="image-pay-wrapper">
                <icon name="ApplePay" :width="24" />
              </div>
              <span>{{
                $t('_web_subscription_payment-method-apple pay', 'Apple Pay')
              }}</span>
            </div>

            <icon
              :class="isRTL ? 'rtl-transform-chevron' : ''"
              name="chevron-right-small"
              :width="24"
            />
          </div>
          <!-- Flagsmith dcb payment-->

          <div
            v-if="$flagsmith.flags.dcb_payment.value"
            class="payment-option"
            @click="selectPaymentOption('mobilePhone')"
          >
            <div class="option-wrapper">
              <div class="image-pay-wrapper">
                <icon name="paywithmobile" :width="24" />
              </div>
              <span>{{
                $t(
                  '_web_subscription_payment-method-dcb',
                  'Pay with Mobile Phone'
                )
              }}</span>
            </div>

            <icon
              :class="isRTL ? 'rtl-transform-chevron' : ''"
              name="chevron-right-small"
              :width="24"
            />
          </div>
          <div
            class="payment-option"
            @click="selectPaymentOption('creditDebitCard')"
          >
            <div class="option-wrapper">
              <div class="image-pay-wrapper">
                <icon name="cards" :width="24" />
              </div>
              <span>{{
                $t(
                  '_web_subscription_payment-method-creditcard',
                  'Credit/Debit Card'
                )
              }}</span>
            </div>

            <icon
              :class="isRTL ? 'rtl-transform-chevron' : ''"
              name="chevron-right-small"
              :width="24"
            />
          </div>
        </div>
        <div v-if="paymentUserOption === 'mobilePhone'" class="mobile-payment">
          <div v-if="!transaction">
            <div v-if="!transaction" class="button-wrapper-modal mb-5">
              <div
                v-if="!transaction"
                class="text-payment-method d-flex flex-column"
              >
                <span style="color: grey;">{{
                  $t(
                    `_web_checkout_shop-provide-information`,
                    'Provide Information'
                  )
                }}</span>
              </div>
              <div
                v-if="!transaction"
                class="image-pay-wrapper"
                style="height: unset;width:unset;padding: 7px;cursor:pointer;"
                @click="goBackMobile"
              >
                <icon
                  name="arrow-left"
                  :width="24"
                  :style="isRTL ? 'rotate:180deg;' : ''"
                />
              </div>
            </div>

            <span class="verify-label ">{{
              $t(`_web_checkout_shop-provider`, 'Provider')
            }}</span>
            <button class="telecom-picker" disabled>
              <icon name="providerPlaceholder" :width="24" />
              {{ providerTelecom }}
            </button>
          </div>
          <InputPhone
            v-if="!transaction"
            v-model="phone"
            name="phone"
            class="mt-5"
            :label="$$t('Mobile Phone (DCB)', 'phone_input_label_dcb')"
          />
          <div v-if="transaction" class="verify-wrapper">
            <div v-if="statusMessage === 'Success'">
              <div class="toast-sucess-payment mb-3">
                {{
                  $t(`_web_checkout_shop-payment-succ`, 'Payment is Sucessfull')
                }}
              </div>
            </div>
            <div v-if="transaction" class="button-wrapper-modal mb-5">
              <div
                v-if="transaction"
                class="text-payment-method d-flex flex-column"
              >
                <span style="color: grey;">{{
                  $t(
                    `_web_checkout_shop-verify-transaction`,
                    'Verify Transaction'
                  )
                }}</span>
              </div>
              <div
                v-if="transaction"
                class="image-pay-wrapper"
                style="height: unset;width:unset;padding: 7px;cursor:pointer;"
                @click="goBackMobile"
              >
                <icon
                  name="arrow-left"
                  :width="24"
                  :style="isRTL ? 'rotate:180deg;' : ''"
                />
              </div>
            </div>
            <span class="verify-text ">{{
              $t(`_web_checkout_shop-pin-code`, 'PIN Code')
            }}</span>
            <InputVerify v-model="code" class="mt-2" tag="form" :count="4" />
            <span
              v-if="statusMessage !== 'Success' && statusMessage.length > 1"
              class="error-message mt-2"
              >{{
                $t(
                  `_web_checkout_shop-payment-failed`,
                  'Payment failed, check your email'
                )
              }}</span
            >
            <div class="verify-text-wrapper mt-5">
              <span class="verify-text">{{
                $t(`_web_checkout_shop-no-code`, `Haven't received the code?`)
              }}</span>
              <button
                class="verify-text-button"
                :disabled="resendDisabled"
                @click="dcbResend"
              >
                {{
                  resendDisabled
                    ? $t(`_web_checkout_shop-resend-in`, `Resend in`) +
                      remainingSeconds
                    : $t(`_web_checkout_shop-resend`, `Resend`)
                }}
              </button>
            </div>
          </div>
        </div>
        <div
          v-show="
            (Object.keys(card).length === 0 &&
              provider !== 'fort' &&
              paymentUserOption === 'creditDebitCard') ||
              (paymentOption !== 'new' &&
                provider !== 'fort' &&
                paymentUserOption === 'creditDebitCard')
          "
          class="w-100"
        >
          <div class="payment-option-wrapper">
            <div class="button-wrapper-modal">
              <div class="text-payment-method d-flex flex-column">
                <TextBlock :size="0.875" class="mb-3" style="color: white">{{
                  $t(
                    `_web_checkout_shop-choose-payment`,
                    'Choose payment method'
                  )
                }}</TextBlock>
                <TextBlock
                  :size="0.75"
                  style="font-size: 12px;font-weight: 400;color: grey"
                  >{{
                    $t(
                      `_web_checkout_shop-saved-methods`,
                      'Saved payment methods'
                    )
                  }}</TextBlock
                >
              </div>
              <div
                v-if="paymentUserOption === 'creditDebitCard'"
                class="image-pay-wrapper"
                style="height: unset;width: unset;padding: 7px;cursor:pointer;"
                @click="goBack"
              >
                <icon
                  name="arrow-left"
                  :width="24"
                  :style="isRTL ? 'rotate:180deg;' : ''"
                />
              </div>
            </div>
            <div
              v-if="isPriceLoading"
              class="payment-spinner-container d-flex flex-column justify-center align-content-center"
            >
              <Spinner class="spiner-payment" />
            </div>
            <div v-if="isPriceLoading ? false : cards.length">
              <div
                class="cards-option-wrapper custom-scrollbar"
                style="max-height: 225px;"
              >
                <div
                  v-for="(item, index) in cards"
                  :key="index"
                  class="payment-option"
                  @click="selectCard(item.cardId)"
                >
                  <div class="option-wrapper">
                    <div class="image-pay-wrapper">
                      <img
                        v-if="item.brand === 'MASTERCARD'"
                        src="@/assets/images/mastercard_payment.png"
                        width="24px"
                      />
                      <icon
                        v-else
                        :name="item.brand.toLowerCase()"
                        :width="24"
                      />
                    </div>
                    <div>XXXX XXXX XXXX {{ item.lastFourDigits }}</div>
                  </div>
                  <input
                    v-model="paymentOption"
                    type="radio"
                    name="paymentOption"
                    :value="item.cardId"
                  />
                </div>
                <div class="payment-option" @click="updateAddCard">
                  <div class="option-wrapper">
                    <div class="image-pay-wrapper">
                      <icon name="credit-card" :width="24" />
                    </div>

                    <div>
                      {{ $t(`_web_checkout_shop-add-new`, 'add new card') }}
                    </div>
                  </div>
                  <icon
                    :class="isRTL ? 'rtl-transform-chevron' : ''"
                    name="chevron-right-small"
                    :width="24"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-show="
            (showCard &&
              provider !== 'fort' &&
              paymentUserOption === 'creditDebitCard') ||
              (paymentOption === 'new' &&
                provider !== 'fort' &&
                paymentUserOption === 'creditDebitCard')
          "
          class="button-wrapper-modal"
        >
          <div class="text-payment-method d-flex flex-column">
            <span style="color: grey;">{{
              $t(
                `_web_checkout_shop-payment-information`,
                'Payment Information'
              )
            }}</span>
          </div>
          <div
            v-if="cards.length"
            class="image-pay-wrapper"
            style="height: unset;width:unset;padding: 7px;cursor:pointer;"
            @click="goBack"
          >
            <icon
              name="arrow-left"
              :width="24"
              :style="isRTL ? 'rotate:180deg;' : ''"
            />
          </div>
          <!-- <div
              v-else
              class="image-pay-wrapper"
              style="height: unset;width:unset;padding: 7px;cursor:pointer;"
              @click="goBackNoCard"
            >
              <icon
                name="arrow-left"
                :width="24"
                :style="isRTL ? 'rotate:180deg;' : ''"
              />
            </div> -->
        </div>
        <div
          v-show="
            (showCard &&
              provider !== 'fort' &&
              paymentUserOption === 'creditDebitCard') ||
              (paymentOption === 'new' &&
                provider !== 'fort' &&
                paymentUserOption === 'creditDebitCard')
          "
          id="element-container"
          class="mt-4"
        ></div>
        <div
          v-show="
            (showCard &&
              provider !== 'fort' &&
              paymentUserOption === 'creditDebitCard') ||
              (paymentOption === 'new' &&
                provider !== 'fort' &&
                paymentUserOption === 'creditDebitCard')
          "
          id="error-handler"
          class="mt-3"
        ></div>
        <div
          v-show="
            (showCard &&
              provider !== 'fort' &&
              paymentUserOption === 'creditDebitCard') ||
              (paymentOption === 'new' &&
                provider !== 'fort' &&
                paymentUserOption === 'creditDebitCard')
          "
          class="server-error"
        >
          {{ error }}
        </div>
        <div
          v-if="
            (paymentOption === 'new' &&
              provider !== 'fort' &&
              paymentUserOption === 'creditDebitCard') ||
              (showCard &&
                !isPriceLoading &&
                provider !== 'fort' &&
                paymentUserOption === 'creditDebitCard')
          "
          class="d-flex save-card-checkout mt-2"
          style="padding: 0px;"
        >
          <input v-model="saveCard" type="checkbox" name="saveCard" />
          <div>
            {{
              $t(
                `_web_checkout_shop-save-new`,
                'Save my card for next purchase'
              )
            }}
          </div>
        </div>
        <!-- Payfort cards +done -->
        <div
          v-if="
            fortCards.length &&
              !isProcessing &&
              paymentOption !== 'new' &&
              paymentUserOption === 'creditDebitCard'
          "
          class="payment-option-wrapper custom-scrollbar"
          style="margin-bottom: 0px;"
        >
          <div class="button-wrapper-modal">
            <div class="text-payment-method d-flex flex-column">
              <span style="color: white;">{{
                $t(`_web_checkout_shop-choose-payment`, 'Choose Payment Method')
              }}</span
              ><span style="font-size: 12px;font-weight: 400;color:grey">{{
                $t(`_web_checkout_shop-saved-methods`, 'Saved payment methods')
              }}</span>
            </div>
            <div
              v-if="paymentUserOption === 'creditDebitCard'"
              class="image-pay-wrapper"
              style="height: unset;width: unset;padding: 7px;cursor:pointer;"
              @click="goBack"
            >
              <icon
                name="arrow-left"
                :width="24"
                :style="isRTL ? 'rotate:180deg;' : ''"
              />
            </div>
          </div>

          <div class="cards-option-wrapper custom-scrollbar">
            <div
              v-for="(item, index) in fortCards"
              :key="index"
              class="payment-option"
              @click="selectCardFort(item)"
            >
              <div class="option-wrapper">
                <div class="image-pay-wrapper">
                  <img
                    v-if="item.card_type === 'MASTERCARD'"
                    src="@/assets/images/mastercard_payment.png"
                    width="24px"
                  />
                  <icon
                    v-else
                    :name="item.card_type.toLowerCase()"
                    :width="24"
                  />
                </div>
                <div :style="{ direction: isRTL ? 'ltr' : '' }">
                  {{ item.card_number }}
                </div>
              </div>
              <div class="option-wrapper">
                <div
                  v-if="paymentOption.id === item.id"
                  class="d-flex cvv-input-container"
                >
                  <input
                    id="card_security_code"
                    v-model="cvv"
                    type="text"
                    name="card_security_code"
                    placeholder="CVV"
                    class="input-cvv-field"
                    @input="handleCvvInput"
                  />
                </div>
                <input
                  v-model="paymentOption"
                  type="radio"
                  name="paymentOption"
                  :value="item"
                />
              </div>
            </div>
          </div>

          <div class="payment-option" @click="updateAddCard">
            <div class="option-wrapper">
              <div class="image-pay-wrapper">
                <icon name="credit-card" :width="24" />
              </div>

              <div>
                {{ $t(`_web_checkout_shop-add-new`, 'add new card') }}
              </div>
            </div>
            <icon
              :class="isRTL ? 'rtl-transform-chevron' : ''"
              name="chevron-right-small"
              :width="24"
            />
          </div>
        </div>
        <div
          v-if="
            provider === 'fort' &&
              paymentOption === 'new' &&
              paymentUserOption === 'creditDebitCard'
          "
          class="button-wrapper-modal"
        >
          <div class="text-payment-method d-flex flex-column">
            <span style="color: white;">{{
              $t(
                `_web_checkout_shop-payment-information`,
                'Payment Information'
              )
            }}</span>
          </div>
          <div
            v-if="fortCards.length"
            class="image-pay-wrapper"
            style="height: unset;width:unset;padding: 7px;cursor:pointer;"
            @click="goBack"
          >
            <icon
              name="arrow-left"
              :width="24"
              :style="isRTL ? 'rotate:180deg;' : ''"
            />
          </div>
          <div
            v-else
            class="image-pay-wrapper"
            style="height: unset;width:unset;padding: 7px;cursor:pointer;"
            @click="goBackNoCard"
          >
            <icon
              name="arrow-left"
              :width="24"
              :style="isRTL ? 'rotate:180deg;' : ''"
            />
          </div>
        </div>

        <PayFort
          v-if="
            provider === 'fort' &&
              paymentOption === 'new' &&
              paymentUserOption === 'creditDebitCard'
          "
          ref="payFortRef"
          :order="product"
          :is-shop="true"
          :coupon="!couponError ? couponCode : null"
          @paymentProcessing="processing"
          @paymentNotProcessing="processingFalse"
        />
        <div
          v-if="cvvMessage"
          class="d-flex flex-column save-card-checkout mx-3 mt-5"
        >
          <p v-if="cvvMessage" class="error-message">{{ cvvMessage }}</p>
        </div>
        <div
          v-if="paymentUserOption !== 'mobilePhone'"
          class="close-modal-btn-container"
          :style="provider !== 'fort' ? 'margin-top:32px;' : ''"
        >
          <div class="checkbox-spacer">
            <Checkbox v-model="termsState" @change="updatePayButtonState" />
            <label for="termsState" class="terms-label">
              <span class="terms-hover" @click="redirectToTermsPage">
                {{
                  $t(
                    `_web_checkout_shop-terms-cond`,
                    'I read and agree to the Terms and conditions.'
                  )
                }}
              </span>
            </label>
          </div>
          <Btn
            id="pay-button"
            class="btn-accent d-flex align-items-center"
            icon="shield-check"
            style="width: 100%;"
            :icon-size="24"
            :label="$t(`_web_checkout_complete-purchase`, 'Complete Purchase')"
            :disabled="isLoading || !enablePayButton || !paymentOption"
            @click="provider === 'fort' ? callPayfortPay() : pay()"
          />
          <button class="close-modal-btn" @click.prevent="cancelAndExit">
            {{ $t('web_create-clan_cancel', 'Cancel') }}
          </button>
          <div class="secure-notice">
            <icon
              name="lock-closed"
              :width="24"
              :fill="$scss.colors.secondaryTextBg"
            />
            <TextBlock
              :size="0.875"
              class="mx-3"
              :variant="'muted'"
              style="font-family: Alexandria;"
            >
              {{
                $t(
                  '_web_your_payment',
                  'Your payment data is encrypted and secure.'
                )
              }}
            </TextBlock>
          </div>
        </div>
        <div v-else>
          <Btn
            v-if="!transaction"
            class="btn-accent d-flex align-items-center"
            style="width: 100%;"
            :label="$t(`_web_checkout_confirm`, 'Confirm')"
            :disabled="phone.length < 8"
            @click="dcb"
          />
          <div v-if="transaction" class="close-modal-btn-container">
            <div class="checkbox-spacer">
              <Checkbox v-model="termsState" @change="updatePayButtonState" />
              <label for="termsState" class="terms-label">
                <span class="terms-hover" @click="redirectToTermsPage">
                  {{
                    $t(
                      `_web_checkout_shop-terms-cond`,
                      'I read and agree to the Terms and conditions.'
                    )
                  }}
                </span>
              </label>
            </div>
            <Btn
              class="btn-accent d-flex align-items-center"
              icon="shield-check"
              style="width: 100%;"
              :label="
                $t(`_web_checkout_complete-purchase`, 'Complete Purchase')
              "
              :disabled="code.length !== 4 || isLoading || !enablePayButton"
              @click="dcbPayment"
            />
            <button class="close-modal-btn" @click.prevent="cancelAndExit">
              {{ $t('web_create-clan_cancel', 'Cancel') }}
            </button>
            <div class="secure-notice">
              <icon
                name="lock-closed"
                :width="24"
                :fill="$scss.colors.secondaryTextBg"
              />
              <TextBlock
                :size="0.875"
                class="mx-3"
                :variant="'muted'"
                style="font-family: Alexandria;"
              >
                {{
                  $t(
                    '_web_your_payment',
                    'Your payment data is encrypted and secure.'
                  )
                }}
              </TextBlock>
            </div>
          </div>
        </div>
      </div>

      <Preloader v-if="isProcessing" :is-loading="isProcessing" has-backdrop />
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { TAP_PUBLIC_KEY } from '@/api/config';
import { translate } from '@/mixins/translate';
import { prop } from '@/utils/factories';
import Spinner from '@/views/main/components/Spinner.vue';
import Btn from '@/components/atoms/HeraFormBtn';
import TextBlock from '@/components/atoms/TextBlock.vue';
import icon from '@/components/atoms/Icon';
import HeraInput from '@/components/atoms/form/HeraFormTextInput';
import Preloader from '@/components/common/HeraListPreloader';
import Checkbox from '@/components/atoms/form/Checkbox.vue';
import PayFort from '@/views/subscription/billing/PayFort.vue';
import InputPhone from '@/components/form/InputPhoneNew';
import InputVerify from '@/components/form/InputVerify';

export default {
  name: 'CheckoutTournament',
  components: {
    Btn,
    TextBlock,
    icon,
    HeraInput,
    Preloader,
    Spinner,
    Checkbox,
    PayFort,
    InputPhone,
    InputVerify,
  },
  mixins: [translate('_web_subscription')],
  props: {
    isLoading: prop(Boolean, false),
    error: prop(String, ''),
    product: prop(String),
    description: prop(Object, {}),
    quantity: prop(Number),
    cards: prop(Array, []),
    provider: prop(String, ''),
  },
  data() {
    return {
      tap: window.Tapjsli(TAP_PUBLIC_KEY),
      card: {},
      fortCards: [],
      // price: {},
      couponCode: null,
      couponError: '',
      couponApplied: false,
      agreed: true,
      isPriceLoading: false,
      isCouponChecking: false,
      isProcessing: false,
      cart: {},
      SelectedProduct: this.description,
      status: '',
      showCard: false,
      paymentOption: '',
      tapError: '',
      saveCard: false,
      termsState: false,
      enablePayButton: false,
      cvvValid: false,
      cvv: '',
      cvvMessage: '',
      paymentUserOption: '',
      phone: '',
      transaction: '',
      code: '',
      statusMessage: '',
      resendDisabled: false,
      countdown: 60,
      countdownInterval: null,
      providerTelecom: 'Zain',
      expireMobile: null,
    };
  },

  computed: {
    ...mapGetters(['currentLocale', 'isRTL']),
    cardType() {
      return this.paymentOption.card_type;
    },
    remainingSeconds() {
      return this.countdown + 's';
    },
  },
  watch: {
    expireMobile(newVal) {
      if (newVal) {
        this.startTimer();
      }
    },
    paymentOption() {
      if (
        (this.paymentOption === 'new' || this.showCard) &&
        this.provider !== 'fort'
      ) {
        if (!document.getElementById('privateTapElement')) {
          this.initTapCard();
        }
      }
    },
    isPriceLoading() {
      if (
        (this.paymentOption === 'new' || this.showCard) &&
        this.provider !== 'fort'
      ) {
        if (!document.getElementById('privateTapElement')) {
          this.initTapCard();
        }
      }
    },
    statusMessage(newVal) {
      if (newVal === 'Success') {
        setTimeout(() => {
          this.cancelAndExit();
        }, 5000);
      }
    },
  },
  created() {
    if (this.provider === 'fort') {
      this.getCardsPayfort().then(res => {
        if (res.cards.length) {
          this.fortCards = res.cards;
        } else {
          this.paymentOption = 'new';
        }
      });
    }
  },
  mounted() {
    if (!this.cards.length && this.provider !== 'fort') {
      this.paymentOption = 'new';
    }
    // this.getPrice();
    if (
      !this.cards.length &&
      !this.isPriceLoading &&
      this.provider !== 'fort'
    ) {
      this.showCard = true;
      this.initTapCard();
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    ...mapActions([
      'checkCoupon',
      'verifyCard',
      'errorNotify',
      'closeModal',
      'fetchOrderById',
      'couponApply',
      'cancelOrder',
      'getCardsPayfort',
      'saveCardPayfortPay',
      'mobilePayment',
      'mobileCharge',
      'resendCodeDCB',
    ]),
    updateAddCard() {
      this.paymentOption = 'new';
    },

    handleCvvInput(event) {
      this.cvvMessage = '';
      this.cvv = event.target.value.replace(/\D/g, '');
    },

    validateCVV(card_cvv, card_type) {
      this.cvvMessage = this.$t(
        '_web_pay_fort_Invalid-CVV',
        'Invalid Card CVV'
      );
      if (card_cvv.length > 0) {
        card_cvv = card_cvv.trim();

        if (card_cvv.length === 3 && card_cvv !== '000') {
          this.cvvValid = true;
          this.cvvMessage = '';
        } else if (
          card_cvv.length === 4 &&
          card_type === 'amex' &&
          card_cvv !== '0000'
        ) {
          this.cvvValid = true;
          this.cvvMessage = '';
        }
      }
    },
    updatePayButtonState() {
      this.enablePayButton = this.termsState;
    },
    dcb() {
      Promise.all([]).then(() => {
        this.mobilePayment({
          orderId: this.product,
          phone: this.phone,
          coupon: this.couponCode,
          provider: this.providerTelecom,
        }).then(res => {
          this.transaction = res.transaction;
          this.expireMobile = res.expires;
        });
      });
    },
    dcbResend() {
      if (this.resendDisabled) {
        return;
      }
      this.startCountdown();
      Promise.all([]).then(() => {
        this.resendCodeDCB({
          transaction: this.transaction,
        }).then(() => {
          this.code = '';
          this.enablePayButton = false;
          this.termsState = false;
        });
      });
    },
    dcbPayment() {
      Promise.all([]).then(() => {
        this.mobileCharge({
          transaction: this.transaction,
          code: this.code,
        }).then(res => {
          if (res.status === 'failed') {
            this.statusMessage = res.message;
          } else if (res.status === 'Success') {
            this.statusMessage = 'Success';
          } else {
            this.statusMessage = '';
          }

          this.code = '';
          this.enablePayButton = false;
          this.termsState = false;
        });
      });
    },
    callPayfortPay() {
      if (this.paymentOption === 'new') {
        this.$refs.payFortRef.tokenization();
      } else {
        Promise.all([
          this.validateCVV(this.cvv, this.paymentOption.card_type),
        ]).then(() => {
          if (this.cvvValid && !this.cvvMessage) {
            this.isProcessing = true;
            this.saveCardPayfortPay({
              orderId: this.product,
              card_id: this.paymentOption.id,
              card_security_code: this.cvv,
              coupon: this.couponCode,
            }).then(res => {
              if (res.redirectUrl) {
                window.location.href = res.redirectUrl;
              }
            });
          }
        });
      }
    },
    processing() {
      this.isProcessing = true;
    },
    processingFalse() {
      this.isProcessing = false;
    },
    initTapCard() {
      if (TAP_PUBLIC_KEY) {
        const elements = this.tap.elements({});

        var style = {
          base: {
            color: '#535353',
            lineHeight: '18px',
            fontFamily: 'sans-serif',
            fontSmoothing: 'antialiased',
            height: '300px',
            fontSize: '16px',
            '::placeholder': {
              color: 'rgba(0, 0, 0, 0.26)',
              fontSize: '15px',
            },
          },
          invalid: {
            color: 'red',
          },
        };

        // input labels/placeholders
        const labels = {
          cardNumber: 'Card Number',
          expirationDate: 'MM/YY',
          cvv: 'CVV',
          cardHolder: 'Card Holder Name',
        };
        //payment options
        const paymentOptions = {
          paymentAllowed: ['VISA', 'MASTERCARD', 'MADA'],
          currencyCode: ['KWD', 'USD', 'SAR'],
          labels: labels,
          TextDirection: 'ltr',
        };
        //create element, pass style and payment options
        const card = elements.create('card', { style: style }, paymentOptions);
        //mount element
        card.mount('#element-container');
        //card change event listener
        card.addEventListener('change', function(event) {
          const displayError = document.getElementById('error-handler');

          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = '';
          }
        });
        this.card = card;
      }
    },

    checkOrder() {
      this.fetchOrderById({ id: this.product })
        .then(res => {
          this.cart = res.price;
          this.SelectedProduct = res.items[0].card;

          if (res.status === 2) {
            this.status = res.status;
            clearInterval(this.intervalId);
            this.isPriceLoading = false;
          } else if (this.iteration >= 15) {
            clearInterval(this.intervalId);
            this.closeModal();
            this.$emit('errorStatus');
          } else {
            this.status = res.status;
            this.iteration++;
          }
        })
        .catch(error => {
          console.error('Error fetching order:', error);
        })
        .finally(() => {});
    },
    cancelAndExit() {
      this.closeModal();
      window.dataLayer.push({
        event: 'shop payment cancelled',
      });
      this.$router.push({
        path: `/tournament/${this.description.origin_tournament_id}`,
        params: {
          accountId: this.description.origin_tournament_id,
          accountType: 'tournament',
        },
      });
    },
    goBack() {
      if (this.paymentOption === 'new') {
        this.paymentOption = '';
      } else {
        this.paymentUserOption = '';
      }
    },
    goBackNoCard() {
      this.paymentUserOption = '';
    },
    goBackMobile() {
      if (this.transaction.length > 0) {
        this.transaction = '';
        this.phone = '';
      } else {
        this.paymentUserOption = '';
      }
    },
    getPrice() {
      this.isPriceLoading = true;
      this.iteration = 1;

      if (this.status !== 2) {
        this.intervalId = setInterval(() => {
          this.checkOrder();
        }, 3500);
      }
    },
    selectPaymentOption(option) {
      this.paymentUserOption = option;
    },
    startCountdown() {
      this.resendDisabled = true;
      this.countdown = 60;

      this.countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.resendDisabled = false;
          clearInterval(this.countdownInterval);
        }
      }, 1000);
    },
    pay() {
      let self = this;
      window.dataLayer.push({
        event: 'shop payment confirmed',
      });
      if (this.paymentOption === 'new') {
        this.tap.createToken(this.card).then(function(result) {
          if (result && result.error && result.error.message) {
            // Inform the user if there was an error
            let errorElement = document.getElementById('error-handler');
            errorElement.textContent = result.error.message;
          } else {
            // self.isProcessing = true;
            self.isProcessing = true;
            self.tokenized(result);
          }
        });
      } else {
        this.isProcessing = true;
        this.$emit('submit', this.paymentOption, this.saveCard);
      }
    },
    redirectToTermsPage() {
      const baseUrl = '/static/terms/';
      const route = this.isRTL ? 'other' : 'mena';
      const url = `${baseUrl}${route}#app2`;
      window.open(url, '_blank');
    },
    apply() {
      this.couponApply({
        orderId: this.product,
        coupon: this.couponCode,
      })
        .then(res => {
          if (res) {
            this.cart = res.price;
            this.couponApplied = true;
            this.couponError = '';
            window.dataLayer.push({
              event: 'shop discount applied',
              discountCode: this.couponCode,
              discountId: this.cart.couponId,
            });
          }
        })
        .catch(() => {
          this.couponError = this.$$t('Wrong code');
          this.couponCode = null;
        })
        .finally(() => {
          this.isCouponChecking = false;
        });
    },
    tokenized(data) {
      this.$emit('submit', data.id, this.saveCard);
    },
    selectCard(cardId) {
      this.paymentOption = cardId;
    },
    selectCardFort(cardId) {
      this.paymentOption = cardId;
    },
    startTimer() {
      if (this.expireMobile) {
        const currentTime = Math.floor(Date.now() / 1000);
        const remainingTime = this.expireMobile - currentTime;
        if (remainingTime > 0) {
          setTimeout(() => {
            this.paymentUserOption = '';
            this.transaction = '';
            this.phone = '';
          }, remainingTime * 100);
        }
      }
    },
  },
};
</script>

<style lang="scss">
#payment-form {
  #element-container {
    width: 400px;
    max-width: 390px;
    border-radius: 8px;
    overflow: hidden;
    padding: 1rem;
    background: white;
  }

  .coupon {
    .wrapper-control {
      width: 300px;
    }

    .apply-coupon-button {
      margin-top: 27px;
      max-height: 40px;

      span {
        color: white !important;
      }
    }
  }

  .coupon-input {
    padding-right: 10px;
  }

  .btn-accent {
    justify-content: center;
  }

  .coupon-input input {
    background-color: #1c212b;
    border: 1px solid transparent;
    width: 160px;
  }

  .coupon-input input:focus {
    border: 1px solid $new-bg-primary;
  }

  #error-handler,
  .server-error {
    color: var(--ph-error);
  }

  &.loading {
    cursor: progress;
  }
}

@media (max-width: 515px) {
  #payment-form,
  #element-container,
  .modalbackdrop_container {
    width: 100% !important;
    max-width: none !important;
    padding: 8px;
    max-height: unset;
  }
}

.close-modal-btn {
  background-color: rgba(218, 0, 0, 1) !important;
  border: none !important;
  color: $hr-bg-modal-btn !important;
  border-radius: 4px;
  font-weight: 700;
  height: 40px !important;
}

.close-modal-btn-container {
  width: 100%;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  gap: 16px;
  > button {
    font-family: Alexandria;
  }
  > button > span {
    font-family: Alexandria;
  }
  .close-modal-btn {
    width: 100% !important;
  }
  @media (max-width: 515px) {
    gap: 9px;
  }
}

.payment-methods {
  display: flex;
  width: 100%;
  min-height: 168px;
  max-height: 168px;
  overflow: auto;
  border-radius: 8px;
  margin-top: 14px;
  padding: 24px 16px;
  gap: 10px;
  margin-bottom: -15px;
  max-width: 100%;
  color: #eff0f1;

  .card-inline {
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;
  }

  @media (max-width: 515px) {
    width: 100%;
  }
}

.payment-spinner-container {
  display: flex;
  background: #242938;
  width: 390px;
  min-height: 168px;
  border-radius: 8px;
  margin-top: 14px;
  padding: 24px 16px;
  gap: 10px;
  margin-bottom: -15px;
  color: #eff0f1;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media (max-width: 515px) {
    width: 100%;
  }
}

.save-card-checkout {
  justify-content: flex-start;
  width: 100% !important;
  gap: 8px;
  padding: 8px;
}

.item-title-shop-checkout {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.input-cvv-field {
  background-color: #18181f;
  border: none;
  min-height: 2.5rem;
  border-radius: 5px;
  color: white;
  max-width: 50px;
  text-align: center;
}

.cvv-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
  color: white;
}

.error-message {
  color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;
}

.form-payment {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 32px;

  .plan-details-shop {
    max-width: 400px;
    min-width: 400px;

    @media (max-width: 515px) {
      min-width: unset;
    }

    label,
    span,
    div,
    .coupon-input {
      color: grey;
      font-family: Alexandria !important;
      font-size: 14px !important;
      font-weight: 600;
      line-height: 20px !important;
      letter-spacing: -0.18px;
    }
  }
}

.form-payment {
  @media (max-width: 930px) {
    flex-direction: column;
    align-items: center;
  }

  .plan-details-shop {
    .coupon {
      .coupon-input {
        div > span {
          color: #eb6666;
          font-family: Exo;
          font-size: 14px !important;
          font-weight: 400;
          line-height: 24px !important;
          margin: 0px 5px;
        }

        div > input {
          width: 100% !important;
        }

        .wrapper-control-label {
          label {
            color: rgba(255, 255, 255, 0.5) !important;
          }
        }
      }
    }
  }
}

.divider-payment {
  height: 2px !important;
  background: rgba(255, 255, 255, 0.2);
  margin: 32px 0;
}

.payment-option-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.payment-option {
  display: flex;
  height: 64px;
  padding: 16px 16px 16px 8px;
  gap: 12px;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

.option-wrapper {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  > span,
  div {
    font-family: Alexandria;
  }
}

.image-pay-wrapper {
  display: flex;
  padding: 11px;
  width: 46px;
  height: 46px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.06);
}

.payment-user-options {
  border-radius: 16px;
  background-color: #1c212b;
  padding: 32px;
  min-width: 460px;
  max-width: 460px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 530px) {
    min-width: 100%;
    padding: 16px;
  }

  .mobile-payment {
    .verify-wrapper {
      .verify-text-button {
        background-color: transparent;
        border: none;
        width: fit-content;
        padding: 0px;
        font-family: Alexandria;
        font-size: 14px;
        font-weight: 500;
        color: rgba(209, 209, 219, 1);
      }

      .verify-text {
        font-family: Alexandria;
        font-size: 14px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.8);
      }

      .input-verify {
        min-height: unset !important;
      }
    }

    .form-group {
      label {
        font-family: Alexandria;
        font-size: 14px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.8);
      }

      .float-dropbox {
        background-color: rgba(51, 55, 64, 1) !important;

        div > .input-search.focused {
          border-bottom-color: unset;
        }

        .list-loader {
          .list-wrapper {
            div {
              max-height: 150px !important;
            }
          }
        }
      }

      .dropbox-list .list-loader .container {
        min-height: 165px;
      }

      .dropbox-list li > :not(hr):hover {
        background-color: rgba(64, 74, 99, 1) !important;
      }

      .float-dropbox.show.float-dropbox-top::after {
        background-color: rgba(51, 55, 64, 1) !important;
      }

      .input-group-prepend {
        button {
          background-color: rgba(255, 255, 255, 0.05) !important;
          height: 2.15rem;
        }
      }

      .hera-input-phone_input:focus {
        box-shadow: unset !important;
      }

      .new-phone-input {
        border-color: rgba(255, 255, 255, 0.04);
        background-color: unset !important;

        input {
          background-color: rgba(255, 255, 255, 0.05) !important;
        }
      }
    }
  }
}

.verify-text-wrapper {
  display: flex;
  flex-direction: column;
}

.verify-label {
  font-family: Alexandria;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  gap: 6px;
}

.telecom-picker {
  border-radius: 4px;
  width: 100%;
  height: 2.15rem;
  border-color: rgba(255, 255, 255, 0.04);
  background-color: rgba(255, 255, 255, 0.05);
  color: white;
  text-align: left;
}

.terms-label,
.payment-method,
.text-payment-method {
  color: white;
  font-family: Alexandria;
  font-size: 14px;
  font-weight: 500;
}

.cards-option-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 230px;
  overflow: auto;
}

.checkbox-spacer {
  display: flex;
  gap: 12px;
}

.rtl-transform-chevron {
  rotate: 180deg;
}

.button-wrapper-modal {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.secure-notice {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style lang="scss" scoped>
.terms-hover:hover {
  text-decoration: underline;
  cursor: pointer;
}
.toast-sucess-payment {
  width: 100%;
  max-width: 100%;
  min-height: 38px;
  padding: 16px;
  border-radius: 8px;
  background: rgb(75, 181, 67);
  color: white;
  border-radius: 8px;
  /* Elevated */
  box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.07),
    0px 5px 10px 0px rgba(0, 0, 0, 0.05);
}
</style>
